import { useEffect, useMemo, useState } from "react";
import PlantDetailHeader from "./plants/PlantDetailHeader";
import PlantKpiPanel from "./plants/PlantKpiPanel";
import PlantTimeline from "./plants/PlantTimeline";
import InterventionPanel from "./plants/InterventionPanel";
import MaintenancePanel from "./plants/MaintenancePanel";
import TechnicalDeadlinesPanel from "./plants/TechnicalDeadlinesPanel";
import PlantDocumentsPanel from "./plants/PlantDocumentsPanel";
import {
  cardStyle,
  sectionTitleStyle,
  primaryButtonStyle,
  secondaryButtonStyle,
  dangerButtonStyle,
  inputStyle,
  emptyBoxStyle,
} from "../ui/styles";

import API, { authFetch } from "../services/api";

function ImpiantiPage({
  impiantoDaAprireId,
  clientePreselezionato,
  onImpiantoAperto,
  apriSchedaCliente,
  setSezione,
  origineAperturaImpianto,
  setOrigineAperturaImpianto,
}) {
  const [plants, setPlants] = useState([]);
  const [clienti, setClienti] = useState([]);
  const [loading, setLoading] = useState(true);

  const [impiantoSelezionato, setImpiantoSelezionato] = useState(null);
  const [vistaDettaglio, setVistaDettaglio] = useState(false);

  const [mostraNuovoImpianto, setMostraNuovoImpianto] = useState(false);
  const [mostraModificaImpianto, setMostraModificaImpianto] = useState(false);
  const [impiantoInModifica, setImpiantoInModifica] = useState(null);

  const [interventi, setInterventi] = useState([]);
  const [manutenzioni, setManutenzioni] = useState([]);
  const [scadenzeTecniche, setScadenzeTecniche] = useState([]);
  const [documentiImpianto, setDocumentiImpianto] = useState([]);

  const [mostraNuovoIntervento, setMostraNuovoIntervento] = useState(false);
  const [mostraNuovaManutenzione, setMostraNuovaManutenzione] = useState(false);
  const [mostraNuovaScadenza, setMostraNuovaScadenza] = useState(false);
  const [mostraNuovoDocumento, setMostraNuovoDocumento] = useState(false);
  const [salvataggioDocumento, setSalvataggioDocumento] = useState(false);
  const [uploadProgressDocumento, setUploadProgressDocumento] = useState(0);

  const utenteCorrente = JSON.parse(localStorage.getItem("utenteCorrente"));
  const isAdmin = utenteCorrente?.role === "admin";

  const [nuovoImpianto, setNuovoImpianto] = useState({
    customer_id: "",
    plant_type: "",
    sector: "",
    category: "",
    brand: "",
    model: "",
    serial_number: "",
    address: "",
    city: "",
    notes: "",
  });

  const [nuovoIntervento, setNuovoIntervento] = useState({
    intervention_type: "",
    technician_name: "",
    outcome: "",
    notes: "",
  });

  const [nuovaManutenzione, setNuovaManutenzione] = useState({
    title: "",
    frequency_months: 12,
    next_due_date: "",
    status: "Programmato",
    notes: "",
  });

  const [nuovaScadenza, setNuovaScadenza] = useState({
    title: "",
    due_date: "",
    status: "Da eseguire",
    notes: "",
  });

  const [nuovoDocumento, setNuovoDocumento] = useState({
  title: "",
  document_type: "",
  file_path: "",
  notes: "",
  expiration_date: "",
  frequency_months: "",
});

  const formatDate = (value) => {
    if (!value) return "—";
    return new Date(value).toLocaleDateString("it-IT");
  };

  const getNomeCliente = (plant) => {
    if (!plant?.customer) return "—";

    return (
      `${plant.customer.first_name || ""} ${plant.customer.last_name || ""}`.trim() ||
      plant.customer.company_name ||
      "—"
    );
  };

  const getStatusBadge = (label) => {
    const text = label || "—";
    const lower = text.toLowerCase();

    let bg = "#e2e8f0";
    let color = "#334155";

    if (lower.includes("attivo") || lower.includes("complet")) {
      bg = "#dcfce7";
      color = "#166534";
    }

    if (lower.includes("program") || lower.includes("da eseguire")) {
      bg = "#fef3c7";
      color = "#92400e";
    }

    if (lower.includes("scad") || lower.includes("ritardo")) {
      bg = "#fee2e2";
      color = "#991b1b";
    }

    return (
      <span
        style={{
          display: "inline-flex",
          padding: "5px 10px",
          borderRadius: "999px",
          fontSize: "12px",
          fontWeight: 700,
          background: bg,
          color,
        }}
      >
        {text}
      </span>
    );
  };

  const caricaImpianti = async () => {
    const res = await authFetch(`${API}/plants/`);

    if (!res.ok) {
      throw new Error("Errore caricamento impianti");
    }

    setPlants(await res.json());
  };

  const caricaClienti = async () => {
    const res = await authFetch(`${API}/customers/`);

    if (!res.ok) {
      throw new Error("Errore caricamento clienti");
    }

    setClienti(await res.json());
  };

  const caricaDatiIniziali = async () => {
    try {
      await Promise.all([caricaImpianti(), caricaClienti()]);
    } catch (err) {
      console.error(err);
      alert("Errore caricamento dati iniziali.");
    } finally {
      setLoading(false);
    }
  };

  const caricaInterventiImpianto = async (plantId) => {
    const res = await authFetch(`${API}/interventions/plant/${plantId}`);

    if (!res.ok) {
      throw new Error("Errore caricamento interventi");
    }

    setInterventi(await res.json());
  };

  const caricaManutenzioniImpianto = async (plantId) => {
    const res = await authFetch(`${API}/maintenance-plans/plant/${plantId}`);

    if (!res.ok) {
      throw new Error("Errore caricamento manutenzioni");
    }

    setManutenzioni(await res.json());
  };

  const caricaScadenzeTecnicheImpianto = async (plantId) => {
    const res = await authFetch(`${API}/technical-deadlines/plant/${plantId}`);

    if (!res.ok) {
      throw new Error("Errore caricamento scadenze tecniche");
    }

    setScadenzeTecniche(await res.json());
  };

  const caricaDocumentiImpianto = async (plantId) => {
    const res = await authFetch(`${API}/plant-documents/plant/${plantId}`);

    if (!res.ok) {
      throw new Error("Errore caricamento documenti impianto");
    }

    setDocumentiImpianto(await res.json());
  };

  const caricaDettaglioImpianto = async (plant) => {
    setImpiantoSelezionato(plant);
    setVistaDettaglio(true);

    try {
      await Promise.all([
        caricaInterventiImpianto(plant.id),
        caricaManutenzioniImpianto(plant.id),
        caricaScadenzeTecnicheImpianto(plant.id),
        caricaDocumentiImpianto(plant.id),
      ]);
    } catch (err) {
      console.error(err);
      alert("Errore caricamento dati impianto.");
    }
  };

  const resetNuovoImpianto = () => {
    setNuovoImpianto({
      customer_id: "",
      plant_type: "",
      brand: "",
      model: "",
      serial_number: "",
      address: "",
      city: "",
      notes: "",
    });
  };

  const salvaNuovoImpianto = async () => {
    if (!nuovoImpianto.customer_id || !nuovoImpianto.plant_type.trim()) {
      alert("Seleziona cliente e tipologia impianto.");
      return;
    }

    try {
      const res = await authFetch(`${API}/plants/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customer_id: Number(nuovoImpianto.customer_id),
          plant_type: nuovoImpianto.plant_type,
          sector: nuovoImpianto.sector || "Altro",
          category: nuovoImpianto.category || "",
          brand: nuovoImpianto.brand,
          model: nuovoImpianto.model,
          serial_number: nuovoImpianto.serial_number,
          address: nuovoImpianto.address,
          city: nuovoImpianto.city,
          notes: nuovoImpianto.notes,
        }),
      });

      if (!res.ok) {
        throw new Error("Errore salvataggio impianto");
      }

      await caricaImpianti();

      resetNuovoImpianto();
      setMostraNuovoImpianto(false);
    } catch (err) {
      console.error(err);
      alert("Errore durante il salvataggio impianto.");
    }
  };

  const apriModificaImpianto = (plant) => {
    setImpiantoInModifica({
      ...plant,
      customer_id: plant.customer_id || "",
      plant_type: plant.plant_type || "",
      brand: plant.brand || "",
      model: plant.model || "",
      serial_number: plant.serial_number || "",
      address: plant.address || "",
      city: plant.city || "",
      notes: plant.notes || "",
    });

    setMostraModificaImpianto(true);
    setMostraNuovoImpianto(false);
  };

  const salvaModificaImpianto = async () => {
    if (!impiantoInModifica) return;

    if (!impiantoInModifica.customer_id || !impiantoInModifica.plant_type.trim()) {
      alert("Seleziona cliente e tipologia impianto.");
      return;
    }

    try {
      const res = await authFetch(`${API}/plants/${impiantoInModifica.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
  customer_id: Number(impiantoInModifica.customer_id),
  plant_type: impiantoInModifica.plant_type,
  sector: impiantoInModifica.sector || "Altro",
  category: impiantoInModifica.category || "",
  brand: impiantoInModifica.brand,
          model: impiantoInModifica.model,
          serial_number: impiantoInModifica.serial_number,
          address: impiantoInModifica.address,
          city: impiantoInModifica.city,
          notes: impiantoInModifica.notes,
        }),
      });

      if (!res.ok) {
        throw new Error("Errore modifica impianto");
      }

      const updatedPlant = await res.json();

      await caricaImpianti();

      if (impiantoSelezionato?.id === updatedPlant.id) {
        setImpiantoSelezionato(updatedPlant);
      }

      setMostraModificaImpianto(false);
      setImpiantoInModifica(null);
    } catch (err) {
      console.error(err);
      alert("Errore durante la modifica impianto.");
    }
  };

  const eliminaImpianto = async (plantId) => {
    const conferma = window.confirm("Vuoi davvero eliminare questo impianto?");
    if (!conferma) return;

    try {
      const res = await authFetch(`${API}/plants/${plantId}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        throw new Error("Errore eliminazione impianto");
      }

      await caricaImpianti();

      if (impiantoSelezionato?.id === plantId) {
        setVistaDettaglio(false);
        setImpiantoSelezionato(null);
      }
    } catch (err) {
      console.error(err);
      alert("Errore durante eliminazione impianto.");
    }
  };

  const salvaNuovoIntervento = async () => {
    if (!impiantoSelezionato) return;

    if (!nuovoIntervento.intervention_type.trim()) {
      alert("Inserisci la tipologia intervento.");
      return;
    }

    try {
      const res = await authFetch(`${API}/interventions/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          plant_id: impiantoSelezionato.id,
          intervention_date: new Date().toISOString(),
          intervention_type: nuovoIntervento.intervention_type,
          technician_name: nuovoIntervento.technician_name,
          status: "Completato",
          outcome: nuovoIntervento.outcome,
          notes: nuovoIntervento.notes,
        }),
      });

      if (!res.ok) throw new Error("Errore salvataggio intervento");

      await caricaInterventiImpianto(impiantoSelezionato.id);

      setNuovoIntervento({
        intervention_type: "",
        technician_name: "",
        outcome: "",
        notes: "",
      });

      setMostraNuovoIntervento(false);
    } catch (err) {
      console.error(err);
      alert("Errore durante il salvataggio intervento.");
    }
  };
  const salvaFirmaIntervento = async (interventionId, firmaCliente) => {
  if (!firmaCliente.trim()) {
    alert("Inserisci la firma del cliente.");
    return;
  }
  
  try {
    const res = await authFetch(
      `${API}/interventions/${interventionId}/signature`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customer_signature: firmaCliente,
        }),
      }
    );

    if (!res.ok) {
      throw new Error("Errore salvataggio firma");
    }

    await caricaInterventiImpianto(impiantoSelezionato.id);

    alert("Firma cliente salvata.");
  } catch (err) {
    console.error(err);
    alert("Errore durante il salvataggio firma.");
  }
};

  const modificaIntervento = async (interventionId, dati) => {
  try {
    const response = await authFetch(
      `${API}/interventions/${interventionId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          intervention_date: dati.intervention_date,
          intervention_type: dati.intervention_type,
          status: dati.status || "Programmato",
          technician_name: dati.technician_name || "",
          outcome: dati.outcome || "",
          notes: dati.notes || "",
          customer_signature: dati.customer_signature || null,
          completion_date: dati.completion_date || null,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Errore modifica intervento");
    }

    if (impiantoSelezionato?.id) {
      await caricaInterventiImpianto(impiantoSelezionato.id);
    }

    alert("Intervento modificato correttamente.");
  } catch (err) {
    console.error(err);
    alert("Errore durante la modifica intervento.");
  }
};

  const salvaNuovaManutenzione = async () => {
    if (!impiantoSelezionato) return;

    if (!nuovaManutenzione.title.trim() || !nuovaManutenzione.next_due_date) {
      alert("Inserisci titolo e prossima scadenza.");
      return;
    }

    try {
      const res = await authFetch(`${API}/maintenance-plans/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          plant_id: impiantoSelezionato.id,
          title: nuovaManutenzione.title,
          frequency_months: Number(nuovaManutenzione.frequency_months),
          next_due_date: nuovaManutenzione.next_due_date,
          status: nuovaManutenzione.status,
          notes: nuovaManutenzione.notes,
        }),
      });

      if (!res.ok) throw new Error("Errore salvataggio manutenzione");

      await caricaManutenzioniImpianto(impiantoSelezionato.id);

      setNuovaManutenzione({
        title: "",
        frequency_months: 12,
        next_due_date: "",
        status: "Programmato",
        notes: "",
      });

      setMostraNuovaManutenzione(false);
    } catch (err) {
      console.error(err);
      alert("Errore durante il salvataggio manutenzione.");
    }
  };

  const completaManutenzione = async (maintenancePlanId) => {
    try {
      const response = await authFetch(
        `${API}/maintenance-plans/${maintenancePlanId}/complete`,
        {
          method: "PATCH",
        }
      );

      if (!response.ok) {
        throw new Error("Errore completamento manutenzione");
      }

      if (impiantoSelezionato?.id) {
        await caricaManutenzioniImpianto(impiantoSelezionato.id);
      }

      alert("Manutenzione completata. Nuova scadenza generata automaticamente.");
    } catch (err) {
      console.error(err);
      alert("Errore durante completamento manutenzione.");
    }
  };

  const modificaManutenzione = async (maintenancePlanId, dati) => {
  try {
    const response = await authFetch(
      `${API}/maintenance-plans/${maintenancePlanId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title: dati.title,
          frequency_months: parseInt(dati.frequency_months),
          next_due_date: dati.next_due_date,
          status: dati.status || "Programmato",
          notes: dati.notes,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Errore modifica manutenzione");
    }

    if (impiantoSelezionato?.id) {
      await caricaManutenzioniImpianto(impiantoSelezionato.id);
    }

    alert("Manutenzione modificata correttamente.");
  } catch (err) {
    console.error(err);
    alert("Errore durante la modifica manutenzione.");
  }
};

  const eliminaManutenzione = async (maintenancePlanId) => {
  const conferma = window.confirm(
    "Vuoi eliminare questa manutenzione?"
  );

  if (!conferma) return;

  try {
    const response = await authFetch(
      `${API}/maintenance-plans/${maintenancePlanId}`,
      {
        method: "DELETE",
      }
    );

    if (!response.ok) {
      throw new Error("Errore eliminazione manutenzione");
    }

    if (impiantoSelezionato?.id) {
      await caricaManutenzioniImpianto(impiantoSelezionato.id);
    }

    alert("Manutenzione eliminata correttamente.");
  } catch (err) {
    console.error(err);
    alert("Errore durante eliminazione manutenzione.");
  }
};

  const salvaNuovaScadenza = async () => {
    if (!impiantoSelezionato) return;

    if (!nuovaScadenza.title.trim() || !nuovaScadenza.due_date) {
      alert("Inserisci titolo e data scadenza.");
      return;
    }

    try {
      const res = await authFetch(`${API}/technical-deadlines/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
  plant_id: impiantoSelezionato.id,
  title: nuovaScadenza.title,
  due_date: nuovaScadenza.due_date,
  frequency_months: nuovaScadenza.frequency_months
    ? parseInt(nuovaScadenza.frequency_months)
    : null,
  status: nuovaScadenza.status,
  notes: nuovaScadenza.notes,
}),
      });

      if (!res.ok) throw new Error("Errore salvataggio scadenza");

      await caricaScadenzeTecnicheImpianto(impiantoSelezionato.id);

      setNuovaScadenza({
  title: "",
  due_date: "",
  frequency_months: "",
  status: "Da eseguire",
  notes: "",
});

      setMostraNuovaScadenza(false);
    } catch (err) {
      console.error(err);
      alert("Errore durante il salvataggio scadenza.");
    }
  };

  const completaScadenzaTecnica = async (technicalDeadlineId) => {
    try {
      const response = await authFetch(
        `${API}/technical-deadlines/${technicalDeadlineId}/complete`,
        {
          method: "PATCH",
        }
      );

      if (!response.ok) {
        throw new Error("Errore completamento verifica tecnica");
      }

      if (impiantoSelezionato?.id) {
        await caricaScadenzeTecnicheImpianto(impiantoSelezionato.id);
      }

      alert("Verifica tecnica completata. Nuova scadenza generata automaticamente.");
    } catch (err) {
      console.error(err);
      alert("Errore durante completamento verifica tecnica.");
    }
  };

  const eliminaScadenzaTecnica = async (technicalDeadlineId) => {
  const conferma = window.confirm(
    "Vuoi eliminare questa scadenza tecnica?"
  );

  if (!conferma) return;

  try {
    const response = await authFetch(
      `${API}/technical-deadlines/${technicalDeadlineId}`,
      {
        method: "DELETE",
      }
    );

    if (!response.ok) {
      throw new Error("Errore eliminazione scadenza");
    }

    if (impiantoSelezionato?.id) {
      await caricaScadenzeTecnicheImpianto(
        impiantoSelezionato.id
      );
    }

    alert("Scadenza eliminata correttamente.");
  } catch (err) {
    console.error(err);
    alert("Errore durante eliminazione scadenza.");
  }
};

const modificaScadenzaTecnica = async (technicalDeadlineId, dati) => {
  try {
    const response = await authFetch(
      `${API}/technical-deadlines/${technicalDeadlineId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title: dati.title,
          due_date: dati.due_date,
          frequency_months: dati.frequency_months
            ? parseInt(dati.frequency_months)
            : null,
          status: dati.status || "Programmato",
          notes: dati.notes,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Errore modifica scadenza tecnica");
    }

    if (impiantoSelezionato?.id) {
      await caricaScadenzeTecnicheImpianto(impiantoSelezionato.id);
    }

    alert("Scadenza tecnica modificata correttamente.");
  } catch (err) {
    console.error(err);
    alert("Errore durante la modifica scadenza tecnica.");
  }
};

  const salvaNuovoDocumento = async () => {
    if (!impiantoSelezionato) return;
    if (salvataggioDocumento) return;

    if (!nuovoDocumento.title.trim()) {
      alert("Inserisci il nome del documento.");
      return;
    }

    if (!nuovoDocumento.file) {
      alert("Seleziona un file da caricare.");
      return;
    }

    setSalvataggioDocumento(true);

    try {
      const formData = new FormData();

      formData.append("title", nuovoDocumento.title);
      formData.append("document_type", nuovoDocumento.document_type || "");
      formData.append("notes", nuovoDocumento.notes || "");
      formData.append("file", nuovoDocumento.file);

      await new Promise((resolve, reject) => {
        const token = localStorage.getItem("token");
        const xhr = new XMLHttpRequest();

        xhr.open("POST", `${API}/plant-documents/upload/${impiantoSelezionato.id}`);
        xhr.setRequestHeader("Authorization", `Bearer ${token}`);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const percent = Math.round((event.loaded * 100) / event.total);
            setUploadProgressDocumento(percent);
          }
        };

        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            setUploadProgressDocumento(100);
            resolve();
          } else {
            reject(new Error("Errore caricamento documento"));
          }
        };

        xhr.onerror = () => {
          reject(new Error("Errore caricamento documento"));
        };

        xhr.send(formData);
      });

      await caricaDocumentiImpianto(impiantoSelezionato.id);

if (nuovoDocumento.expiration_date) {
  await authFetch(`${API}/technical-deadlines/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      plant_id: impiantoSelezionato.id,
      title: nuovoDocumento.title,
      due_date: nuovoDocumento.expiration_date,
      frequency_months: nuovoDocumento.frequency_months
        ? parseInt(nuovoDocumento.frequency_months)
        : null,
      status: "Programmato",
      notes: `Generata automaticamente dal documento "${nuovoDocumento.title}"`,
    }),
  });

  await caricaScadenzeTecnicheImpianto(impiantoSelezionato.id);
}
      
      setNuovoDocumento({
  title: "",
  document_type: "",
  file: null,
  notes: "",
  expiration_date: "",
  frequency_months: "",
});

      setMostraNuovoDocumento(false);

      alert("Documento caricato correttamente.");
    } catch (err) {
      console.error(err);
      alert("Errore durante il caricamento del documento.");
    } finally {
      setSalvataggioDocumento(false);
      setUploadProgressDocumento(0);
    }
  };

  useEffect(() => {
    caricaDatiIniziali();
  }, []);

  useEffect(() => {
    if (!clientePreselezionato) return;

    setVistaDettaglio(false);
    setImpiantoSelezionato(null);
    setMostraModificaImpianto(false);
    setImpiantoInModifica(null);

    setNuovoImpianto((prev) => ({
      ...prev,
      customer_id: clientePreselezionato.id,
      city: clientePreselezionato.city || "",
      address: clientePreselezionato.address || "",
    }));

    setMostraNuovoImpianto(true);
  }, [clientePreselezionato]);

  useEffect(() => {
    if (!impiantoDaAprireId || plants.length === 0) return;

    const impianto = plants.find((p) => p.id === impiantoDaAprireId);

    if (impianto) {
      caricaDettaglioImpianto(impianto);

      if (onImpiantoAperto) {
        onImpiantoAperto();
      }
    }
  }, [impiantoDaAprireId, plants]);

  const calcolaStatoImpianto = () => {
    const oggi = new Date();
    oggi.setHours(0, 0, 0, 0);

    const entro30Giorni = new Date();
    entro30Giorni.setDate(entro30Giorni.getDate() + 30);
    entro30Giorni.setHours(23, 59, 59, 999);

    const manutenzioniScadute = manutenzioni.filter((item) => {
      if (!item.next_due_date) return false;
      return new Date(item.next_due_date) < oggi;
    });

    const verificheScadute = scadenzeTecniche.filter((item) => {
      if (!item.due_date) return false;
      return new Date(item.due_date) < oggi;
    });

    const manutenzioniImminenti = manutenzioni.filter((item) => {
      if (!item.next_due_date) return false;

      const data = new Date(item.next_due_date);
      return data >= oggi && data <= entro30Giorni;
    });

    const verificheImminenti = scadenzeTecniche.filter((item) => {
      if (!item.due_date) return false;

      const data = new Date(item.due_date);
      return data >= oggi && data <= entro30Giorni;
    });

    if (manutenzioniScadute.length > 0 || verificheScadute.length > 0) {
      return {
        label: "Critico",
        type: "danger",
        color: "#b91c1c",
        background: "#fee2e2",
        description: "Sono presenti manutenzioni o verifiche oltre la data prevista.",
      };
    }

    if (manutenzioniImminenti.length > 0 || verificheImminenti.length > 0) {
      return {
        label: "Da monitorare",
        type: "warning",
        color: "#92400e",
        background: "#fef3c7",
        description: "Sono presenti attività tecniche previste entro i prossimi 30 giorni.",
      };
    }

    return {
      label: "Conforme",
      type: "ok",
      color: "#166534",
      background: "#dcfce7",
      description: "Non risultano criticità tecniche o scadenze imminenti.",
    };
  };

  const statoImpianto = calcolaStatoImpianto();

  const ultimoIntervento = interventi.length > 0 ? interventi[0] : null;
  const prossimaManutenzione = manutenzioni.length > 0 ? manutenzioni[0] : null;

  const timelineTecnica = useMemo(() => {
    return [
      ...interventi.map((item) => ({
        id: `intervento-${item.id}`,
        tipo: "Intervento",
        titolo: item.intervention_type,
        data: item.intervention_date,
        descrizione: item.outcome || item.notes || "Intervento registrato",
      })),
      ...manutenzioni.map((item) => ({
        id: `manutenzione-${item.id}`,
        tipo: "Manutenzione",
        titolo: item.title,
        data: item.next_due_date,
        descrizione: item.notes || "Manutenzione programmata",
      })),
      ...scadenzeTecniche.map((item) => ({
        id: `scadenza-${item.id}`,
        tipo: "Scadenza tecnica",
        titolo: item.title,
        data: item.due_date,
        descrizione: item.notes || "Scadenza tecnica registrata",
      })),
      ...documentiImpianto.map((item) => ({
        id: `documento-${item.id}`,
        tipo: "Documento",
        titolo: item.title,
        data: item.created_at,
        descrizione: item.notes || item.file_path || "Documento caricato",
      })),
    ].sort((a, b) => new Date(b.data) - new Date(a.data));
  }, [interventi, manutenzioni, scadenzeTecniche, documentiImpianto]);

  const renderActions = (onSave, onCancel, label) => (
    <div style={{ display: "flex", gap: "10px" }}>
      <button className="btn btn-primary" onClick={onSave} style={primaryButtonStyle}>
        {label}
      </button>

      <button className="btn btn-secondary" onClick={onCancel} style={secondaryButtonStyle}>
        Annulla
      </button>
    </div>
  );

  const categoriePerSettore = {
  "Climatizzazione invernale": [
    "Caldaia",
    "Pompa di calore",
    "Centrale termica",
    "Radiatore",
    "Pannello radiante",
  ],

  "Climatizzazione estiva": [
    "Chiller",
    "Pompa di calore",
    "Fan Coil",
    "UTA",
    "Rooftop",
  ],

  Piscine: [
    "Piscina",
    "Filtro",
    "Pompa",
    "Dosaggio chimico",
    "Scambiatore",
    "Deumidificatore",
  ],

  "Trattamento acque": [
    "Addolcitore",
    "Osmosi inversa",
    "Filtro",
    "Debatterizzatore UV",
    "Dosatore",
  ],

  Irrigazione: [
    "Centralina",
    "Pompa",
    "Elettrovalvola",
  ],

  Idrosanitari: [
    "Autoclave",
    "Bollitore",
    "Scaldacqua",
  ],

  Fotovoltaico: [
    "Impianto FV",
    "Inverter",
    "Accumulo",
    "Wallbox",
  ],

  "Trattamento aria": [
    "UTA",
    "Recuperatore",
    "Ventilatore",
  ],

  Altro: ["Altro"],
};

  const renderImpiantoForm = ({
  titolo,
  dati,
  setDati,
  onSave,
  onCancel,
  testoBottone,
}) => {
  const fieldBoxStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  };

  const helperStyle = {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: "1.35",
  };

  const labelStyle = {
    fontSize: "13px",
    fontWeight: 700,
    color: "#475569",
  };

  return (
    <div style={{ ...cardStyle, marginBottom: "24px" }}>
      <h2 style={{ marginTop: 0, marginBottom: "20px", color: "#0f3c75" }}>
        {titolo}
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "16px",
        }}
      >
        <div style={fieldBoxStyle}>
          <label style={labelStyle}>Cliente</label>
          <select
            value={dati.customer_id || ""}
            onChange={(e) =>
              setDati({
                ...dati,
                customer_id: e.target.value,
              })
            }
            style={inputStyle}
          >
            <option value="">Seleziona cliente</option>
            {clienti.map((cliente) => (
              <option key={cliente.id} value={cliente.id}>
                {`${cliente.first_name || ""} ${cliente.last_name || ""}`.trim() ||
                  cliente.company_name ||
                  `Cliente #${cliente.id}`}
              </option>
            ))}
          </select>
          <div style={helperStyle}>
            Seleziona il cliente proprietario o responsabile dell’impianto.
          </div>
        </div>

        <div style={fieldBoxStyle}>
          <label style={labelStyle}>Tipologia libera</label>
          <input
            type="text"
            placeholder="Esempio: Piscina fuori terra, Daikin Altherma 16 kW"
            value={dati.plant_type || ""}
            onChange={(e) =>
              setDati({
                ...dati,
                plant_type: e.target.value,
              })
            }
            style={inputStyle}
          />
          <div style={helperStyle}>
            Descrizione libera dell’impianto. Può contenere modello commerciale,
            potenza, uso o dettaglio utile all’azienda.
          </div>
        </div>

        <div style={fieldBoxStyle}>
          <label style={labelStyle}>Settore</label>
          <select
            value={dati.sector || ""}
            onChange={(e) =>
              setDati({
                ...dati,
                sector: e.target.value,
                category: "",
              })
            }
            style={inputStyle}
          >
            <option value="">Seleziona settore</option>
            <option value="Climatizzazione invernale">
              Climatizzazione invernale
            </option>
            <option value="Climatizzazione estiva">
              Climatizzazione estiva
            </option>
            <option value="Piscine">Piscine</option>
            <option value="Trattamento acque">Trattamento acque</option>
            <option value="Irrigazione">Irrigazione</option>
            <option value="Idrosanitari">Idrosanitari</option>
            <option value="Depurazione acque reflue">
              Depurazione acque reflue
            </option>
            <option value="Depurazione arsenico">Depurazione arsenico</option>
            <option value="Wellness spa">Wellness spa</option>
            <option value="Trattamento aria">Trattamento aria</option>
            <option value="Ristrutturazioni edili">
              Ristrutturazioni edili
            </option>
            <option value="Servizio assistenza">Servizio assistenza</option>
            <option value="Altro">Altro</option>
          </select>
          <div style={helperStyle}>
            Macro-area tecnica usata per filtri, statistiche e analisi aziendali.
          </div>
        </div>

        <div style={fieldBoxStyle}>
          <label style={labelStyle}>Categoria</label>
          <select
  value={dati.category || ""}
  onChange={(e) =>
    setDati({
      ...dati,
      category: e.target.value,
    })
  }
  disabled={!dati.sector}
  style={inputStyle}
>
            <option value="">
  {dati.sector
    ? "Seleziona categoria"
    : "Prima seleziona un settore"}
</option>

            {(categoriePerSettore[dati.sector || "Altro"] || ["Altro"]).map(
              (categoria) => (
                <option key={categoria} value={categoria}>
                  {categoria}
                </option>
              )
            )}
          </select>
          <div style={helperStyle}>
            Famiglia tecnica dell’impianto. Le categorie cambiano in base al
            settore selezionato.
          </div>
        </div>

        <div style={fieldBoxStyle}>
          <label style={labelStyle}>Marca</label>
          <input
            type="text"
            placeholder="Esempio: Daikin, Vaillant, AstralPool"
            value={dati.brand || ""}
            onChange={(e) =>
              setDati({
                ...dati,
                brand: e.target.value,
              })
            }
            style={inputStyle}
          />
          <div style={helperStyle}>
            Inserisci il produttore o il marchio principale dell’impianto.
          </div>
        </div>

        <div style={fieldBoxStyle}>
          <label style={labelStyle}>Modello</label>
          <input
            type="text"
            placeholder="Esempio: EcoTEC Plus, Altherma 3, Cantabric"
            value={dati.model || ""}
            onChange={(e) =>
              setDati({
                ...dati,
                model: e.target.value,
              })
            }
            style={inputStyle}
          />
          <div style={helperStyle}>
            Indica il modello tecnico o commerciale riportato sulla macchina.
          </div>
        </div>

        <div style={fieldBoxStyle}>
          <label style={labelStyle}>Matricola</label>
          <input
            type="text"
            placeholder="Numero di serie / matricola"
            value={dati.serial_number || ""}
            onChange={(e) =>
              setDati({
                ...dati,
                serial_number: e.target.value,
              })
            }
            style={inputStyle}
          />
          <div style={helperStyle}>
            Codice identificativo utile per assistenza, garanzia e ricambi.
          </div>
        </div>

        <div style={fieldBoxStyle}>
          <label style={labelStyle}>Città</label>
          <input
            type="text"
            placeholder="Comune in cui si trova l’impianto"
            value={dati.city || ""}
            onChange={(e) =>
              setDati({
                ...dati,
                city: e.target.value,
              })
            }
            style={inputStyle}
          />
          <div style={helperStyle}>
            Località dell’impianto, utile per filtri territoriali e interventi.
          </div>
        </div>

        <div style={{ ...fieldBoxStyle, gridColumn: "1 / -1" }}>
          <label style={labelStyle}>Indirizzo</label>
          <input
            type="text"
            placeholder="Via, numero civico, interno o riferimento"
            value={dati.address || ""}
            onChange={(e) =>
              setDati({
                ...dati,
                address: e.target.value,
              })
            }
            style={inputStyle}
          />
          <div style={helperStyle}>
            Inserisci l’indirizzo preciso o un riferimento utile al tecnico.
          </div>
        </div>

        <div style={{ ...fieldBoxStyle, gridColumn: "1 / -1" }}>
          <label style={labelStyle}>Note operative</label>
          <textarea
            placeholder="Esempio: accesso da locale tecnico, chiavi presso portineria, verificare pressione..."
            value={dati.notes || ""}
            onChange={(e) =>
              setDati({
                ...dati,
                notes: e.target.value,
              })
            }
            rows={4}
            style={{
              ...inputStyle,
              resize: "vertical",
            }}
          />
          <div style={helperStyle}>
            Aggiungi informazioni utili per manutenzioni, verifiche, accessi o
            particolarità tecniche.
          </div>
        </div>
      </div>

      <div style={{ display: "flex", gap: "12px", marginTop: "24px" }}>
        <button
          className="btn btn-primary"
          onClick={onSave}
          style={primaryButtonStyle}
        >
          {testoBottone}
        </button>

        <button
          className="btn btn-secondary"
          onClick={onCancel}
          style={secondaryButtonStyle}
        >
          Annulla
        </button>
      </div>
    </div>
  );
};

  if (vistaDettaglio && impiantoSelezionato) {
    return (
      <>
       <div
  style={{
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: "20px",
  }}
>
  <button
    onClick={() => {
      if (origineAperturaImpianto === "dashboard") {
  setVistaDettaglio(false);
  setImpiantoSelezionato(null);
  setOrigineAperturaImpianto("impianti");
  setSezione("home");
  return;
}

    if (origineAperturaImpianto === "cliente") {
  setVistaDettaglio(false);
  setImpiantoSelezionato(null);
  setOrigineAperturaImpianto("impianti");
  setSezione("clienti");
  return;
}

      setVistaDettaglio(false);
      setImpiantoSelezionato(null);
      setInterventi([]);
      setManutenzioni([]);
      setScadenzeTecniche([]);
      setDocumentiImpianto([]);
      setMostraNuovoIntervento(false);
      setMostraNuovaManutenzione(false);
      setMostraNuovaScadenza(false);
      setMostraNuovoDocumento(false);
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "#dbeafe";
      e.currentTarget.style.boxShadow =
        "0 4px 12px rgba(15,60,117,0.12)";
      e.currentTarget.style.transform = "translateY(-1px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "#f1f5f9";
      e.currentTarget.style.boxShadow = "none";
      e.currentTarget.style.transform = "translateY(0)";
    }}
    style={{
      background: "#f1f5f9",
      color: "#0f3c75",
      border: "1px solid #dbe4f0",
      borderRadius: "10px",
      padding: "10px 18px",
      cursor: "pointer",
      fontWeight: 700,
      fontSize: "14px",
      transition: "all 0.2s ease",
    }}
  >
    {origineAperturaImpianto === "dashboard"
  ? "← Torna alla dashboard"
  : origineAperturaImpianto === "cliente"
  ? "← Torna agli impianti del cliente"
  : "← Torna agli impianti"}
  </button>
</div> 

        <div style={cardStyle}>
          <PlantDetailHeader
  impianto={impiantoSelezionato}
  statoImpianto={statoImpianto}
  getNomeCliente={getNomeCliente}
  primaryButtonStyle={primaryButtonStyle}
  secondaryButtonStyle={secondaryButtonStyle}

  onNuovoIntervento={() => {
    setMostraNuovoIntervento(true);
    setMostraNuovoDocumento(false);
    setMostraModificaImpianto(false);
  }}

  onModificaImpianto={() => {
    apriModificaImpianto(impiantoSelezionato);
    setMostraNuovoIntervento(false);
    setMostraNuovoDocumento(false);
  }}

  onNuovoDocumento={() => {
    setMostraNuovoDocumento(true);
    setMostraNuovoIntervento(false);
    setMostraModificaImpianto(false);
  }}

  onOpenCustomer={(customerId) => {
  const clienteTrovato = clienti.find(
    (cliente) => cliente.id === Number(customerId)
  );

  if (clienteTrovato && apriSchedaCliente) {
    apriSchedaCliente(clienteTrovato);
    setSezione("clienti");
  }
}}
/>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1.2fr 1fr",
              gap: "22px",
            }}
          >
            <div>
              <h2 style={sectionTitleStyle}>Dati tecnici</h2>

              <div
                style={{
                  marginTop: "14px",
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: "12px 18px",
                }}
              >
                <div>
                  <strong>Modello:</strong> {impiantoSelezionato.model || "—"}
                </div>

                <div>
                  <strong>Città:</strong> {impiantoSelezionato.city || "—"}
                </div>

                <div style={{ gridColumn: "1 / -1" }}>
                  <strong>Indirizzo:</strong> {impiantoSelezionato.address || "—"}
                </div>

                <div style={{ gridColumn: "1 / -1" }}>
                  <strong>Note:</strong> {impiantoSelezionato.notes || "—"}
                </div>

                <div style={{ gridColumn: "1 / -1", marginTop: "12px" }}>
                  <button
                    className="btn btn-secondary"
                    onClick={() => apriModificaImpianto(impiantoSelezionato)}
                    style={{
                      ...secondaryButtonStyle,
                      marginRight: "8px",
                    }}
                  >
                    Modifica impianto
                  </button>

                  {isAdmin && (
                    <button
                      className="btn btn-danger"
                      onClick={() => eliminaImpianto(impiantoSelezionato.id)}
                      style={dangerButtonStyle}
                    >
                      Elimina impianto
                    </button>
                  )}
                </div>
              </div>
            </div>

            <PlantKpiPanel
  ultimoIntervento={ultimoIntervento}
  prossimaManutenzione={prossimaManutenzione}
  scadenzeTecniche={scadenzeTecniche}
  documentiImpianto={documentiImpianto}
  sectionTitleStyle={sectionTitleStyle}
  getStatusBadge={getStatusBadge}
/>
</div>

<div id="plant-action-area" style={{ marginTop: "24px" }} />

{mostraModificaImpianto &&
  impiantoInModifica &&
  renderImpiantoForm({
    titolo: "Modifica impianto",
    dati: impiantoInModifica,
    setDati: setImpiantoInModifica,
    onSave: salvaModificaImpianto,
    onCancel: () => {
      setMostraModificaImpianto(false);
      setImpiantoInModifica(null);
    },
    testoBottone: "Salva modifiche",
  })}

          <div style={{ marginTop: "30px" }}>
            <PlantTimeline
              timelineTecnica={timelineTecnica}
              sectionTitleStyle={sectionTitleStyle}
            />
          </div>

          <div
            style={{
              marginTop: "30px",
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
              gap: "22px",
            }}
          >
            <InterventionPanel
              cardStyle={cardStyle}
              emptyBoxStyle={emptyBoxStyle}
              inputStyle={inputStyle}
              sectionTitleStyle={sectionTitleStyle}
              primaryButtonStyle={primaryButtonStyle}
              secondaryButtonStyle={secondaryButtonStyle}
              interventi={interventi}
              mostraNuovoIntervento={mostraNuovoIntervento}
              nuovoIntervento={nuovoIntervento}
              setMostraNuovoIntervento={setMostraNuovoIntervento}
              setNuovoIntervento={setNuovoIntervento}
              salvaNuovoIntervento={salvaNuovoIntervento}
              salvaFirmaIntervento={salvaFirmaIntervento}
              modificaIntervento={modificaIntervento}
              formatDate={formatDate}
              renderActions={renderActions}
            />

            <MaintenancePanel
              cardStyle={cardStyle}
              emptyBoxStyle={emptyBoxStyle}
              inputStyle={inputStyle}
              sectionTitleStyle={sectionTitleStyle}
              primaryButtonStyle={primaryButtonStyle}
              manutenzioni={manutenzioni}
              mostraNuovaManutenzione={mostraNuovaManutenzione}
              nuovaManutenzione={nuovaManutenzione}
              setMostraNuovaManutenzione={setMostraNuovaManutenzione}
              setNuovaManutenzione={setNuovaManutenzione}
              salvaNuovaManutenzione={salvaNuovaManutenzione}
              completaManutenzione={completaManutenzione}
              eliminaManutenzione={eliminaManutenzione}
              modificaManutenzione={modificaManutenzione}
              formatDate={formatDate}
              getStatusBadge={getStatusBadge}
              renderActions={renderActions}
            />

            <TechnicalDeadlinesPanel
              cardStyle={cardStyle}
              emptyBoxStyle={emptyBoxStyle}
              inputStyle={inputStyle}
              sectionTitleStyle={sectionTitleStyle}
              primaryButtonStyle={primaryButtonStyle}
              scadenzeTecniche={scadenzeTecniche}
              mostraNuovaScadenza={mostraNuovaScadenza}
              nuovaScadenza={nuovaScadenza}
              setMostraNuovaScadenza={setMostraNuovaScadenza}
              setNuovaScadenza={setNuovaScadenza}
              salvaNuovaScadenza={salvaNuovaScadenza}
              completaScadenzaTecnica={completaScadenzaTecnica}
              eliminaScadenzaTecnica={eliminaScadenzaTecnica}
              modificaScadenzaTecnica={modificaScadenzaTecnica}
              formatDate={formatDate}
              getStatusBadge={getStatusBadge}
              renderActions={renderActions}
            />

            <PlantDocumentsPanel
              cardStyle={cardStyle}
              emptyBoxStyle={emptyBoxStyle}
              inputStyle={inputStyle}
              sectionTitleStyle={sectionTitleStyle}
              primaryButtonStyle={primaryButtonStyle}
              documentiImpianto={documentiImpianto}
              mostraNuovoDocumento={mostraNuovoDocumento}
              nuovoDocumento={nuovoDocumento}
              setMostraNuovoDocumento={setMostraNuovoDocumento}
              setNuovoDocumento={setNuovoDocumento}
              salvaNuovoDocumento={salvaNuovoDocumento}
              salvataggioDocumento={salvataggioDocumento}
              uploadProgressDocumento={uploadProgressDocumento}
              onDocumentoEliminato={(documentId) => {
                setDocumentiImpianto((prev) =>
                  prev.filter((doc) => doc.id !== documentId)
                );
              }}
              renderActions={renderActions}
            />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <div>
          <h1
            style={{
              color: "#173a63",
              fontSize: "32px",
              fontWeight: 400,
              marginBottom: "8px",
            }}
          >
            Impianti
          </h1>

          <p style={{ color: "#4b5563", fontSize: "16px" }}>
            Gestisci impianti, manutenzioni e documentazione tecnica
          </p>
        </div>

        {utenteCorrente?.role !== "viewer" && (
          <button
            className="btn btn-primary"
            onClick={() => {
              resetNuovoImpianto();
              setMostraNuovoImpianto(true);
              setMostraModificaImpianto(false);
              setImpiantoInModifica(null);
            }}
            style={primaryButtonStyle}
          >
            + Nuovo impianto
          </button>
        )}
      </div>

      {mostraNuovoImpianto &&
        renderImpiantoForm({
          titolo: "Nuovo impianto",
          dati: nuovoImpianto,
          setDati: setNuovoImpianto,
          onSave: salvaNuovoImpianto,
          onCancel: () => {
            resetNuovoImpianto();
            setMostraNuovoImpianto(false);
          },
          testoBottone: "Salva impianto",
        })}

      {mostraModificaImpianto &&
        impiantoInModifica &&
        !vistaDettaglio &&
        renderImpiantoForm({
          titolo: "Modifica impianto",
          dati: impiantoInModifica,
          setDati: setImpiantoInModifica,
          onSave: salvaModificaImpianto,
          onCancel: () => {
            setMostraModificaImpianto(false);
            setImpiantoInModifica(null);
          },
          testoBottone: "Salva modifiche",
        })}

      <div
  style={{
  ...cardStyle,
  maxHeight: plants.length > 10 ? "650px" : "none",
  overflowY: plants.length > 10 ? "auto" : "visible",
}}
>
        {loading ? (
          <p>Caricamento impianti...</p>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
  <tr style={{ backgroundColor: "#f1f5f9", textAlign: "left" }}>
    {[
  "Cliente",
  "Settore",
  "Categoria",
  "Tipologia",
  "Marca",
  "Modello",
  "Matricola",
  "Azioni",
].map(
      (header) => (
        <th
          key={header}
          style={{
            padding: "14px",
            position: "sticky",
            top: 0,
            backgroundColor: "#f1f5f9",
            zIndex: 2,
          }}
        >
          {header}
        </th>
      )
    )}
  </tr>
</thead>

            <tbody>
              {plants.map((plant) => (
                <tr key={plant.id} style={{ borderTop: "1px solid #e2e8f0" }}>
                  <td style={{ padding: "14px" }}>{getNomeCliente(plant)}</td>

<td style={{ padding: "14px" }}>
  {plant.sector || "-"}
</td>

<td style={{ padding: "14px" }}>
  {plant.category || "-"}
</td>

<td style={{ padding: "14px" }}>
  {plant.plant_type || "-"}
</td>

<td style={{ padding: "14px" }}>
  {plant.brand || "-"}
</td>

<td style={{ padding: "14px" }}>
  {plant.model || "-"}
</td>

<td style={{ padding: "14px" }}>
  {plant.serial_number || "-"}
</td>

                  <td style={{ padding: "14px" }}>
                    <button
                      className="btn btn-secondary"
                      onClick={() => caricaDettaglioImpianto(plant)}
                      style={{
                        ...secondaryButtonStyle,
                        marginRight: "8px",
                      }}
                    >
                      Apri
                    </button>

                    {utenteCorrente?.role !== "viewer" && (
                      <button
                        className="btn btn-secondary"
                        onClick={() => apriModificaImpianto(plant)}
                        style={{
                          ...secondaryButtonStyle,
                          marginRight: "8px",
                        }}
                      >
                        Modifica
                      </button>
                    )}

                    {isAdmin && (
                      <button
                        className="btn btn-danger"
                        onClick={() => eliminaImpianto(plant.id)}
                        style={dangerButtonStyle}
                      >
                        Elimina
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

export default ImpiantiPage;